import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { throttle, take } from 'rxjs/operators';

interface IOutput {
  id: string;
  rowsPerPage: number;
  currentPage: number;
}

@Component({
  selector: 'app-halo-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {
  currentPage: number;
  rowsPerPage: number;
  pages: number[] = [];
  
  @Input() records:number;
  @Input() id: string;
  @Input() pageOptions:number[] = [10, 20, 30, 0];
  @Output() update = new EventEmitter<IOutput>();

  constructor() {}

  ngOnInit(): void {
    const allOptionIndex = this.pageOptions.findIndex(item => item === 0);
    let defaultSelection = allOptionIndex !== -1 && allOptionIndex === 0 ? 1 : 0;
    this.rowsPerPage = this.pageOptions[defaultSelection];
    this.rowsPerPageChanged();
  }

  ngOnChanges(changes : SimpleChanges){
    if(changes.records && !changes.records.isFirstChange() 
      && changes.records.currentValue !== changes.records.previousValue){
        this.rowsPerPageChanged();
    }
  }

  setCurrentPage(_currentPage: number) {
    if(this.currentPage === _currentPage || _currentPage < 1 || _currentPage > this.pages.length) return;
    this.currentPage = _currentPage;
    this._update();
  }

  rowsPerPageChanged() {
    this.rowsPerPage = Number(this.rowsPerPage);
    if(this.rowsPerPage > 0) {
      let _pagesLength = Math.ceil(this.records / this.rowsPerPage);
      this.pages = [...Array(_pagesLength)].map((_, i) => 1 + i);
    }
    this.currentPage = 1;
    this._update();
  }

  _update() {
    let _params: IOutput = {
      id: this.id,
      currentPage: this.currentPage,
      rowsPerPage: this.rowsPerPage > 0 ? this.rowsPerPage : this.records
    }; 
    this.update.emit(_params);
  }
}

